import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    StringSignal
 *
 *     @author Alexander
 */

export class StringSignal extends GoodgameSignal {
    constructor() {
        super(String);
    }

    public signal(_string: string): void {
        super.dispatch(_string);
    }
}
